import React from 'react';

const Benefits: React.FC = () => {
  const benefits = [
    {
      icon: "💰", // I need to use the exact icon from screenshot
      title: "Pouvoir d'achat",
      subtitle: "Augmentez le pouvoir d'achat de vos collaborateurs avec notre programme de CashBack Planet"
    },
    {
      icon: "🌱", // I need to use the exact icon from screenshot
      title: "Impact environnemental",
      subtitle: "Réduisez votre empreinte carbone grâce à l'économie circulaire"
    },
    {
      icon: "🏢", // I need to use the exact icon from screenshot
      title: "Image employeur",
      subtitle: "Renforcez votre marque employeur et engagez vos collaborateurs"
    }
  ];

  return (
    <section className="benefits">
      <div className="container">
        <h2 className="section-title">Un avantage salarié innovant</h2>
        <p className="section-subtitle">Réconcilier pouvoir d'achat et économie circulaire pour vos collaborateurs</p>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
